export enum AdCampaignPlacement {
  Default = 'default',
  Home = 'home',
  Infos = 'infos',
  Ticker = 'ticker',
  Overview = 'overview',
  Lineup = 'lineup',
  Table = 'table',
  News = 'news',
  Events = 'events',
  Videos = 'videos',
  Teams = 'teams',
  Squad = 'squad',
  PreRoll = 'pre_roll',
  PostRoll = 'post_roll',
}
